/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-09-09 11:16:12
 * @LastEditTime: 2020-07-02 10:01:04
 * @LastEditors: 陆伟
 */
// eslint-disable-next-line import/extensions
import YunJi from '@/assets/js/YunJi'
// eslint-disable-next-line import/extensions
import * as Http from '@/pages/commodity/api/category'

const shopId = YunJi.getUrlParams('shopId')
const ticket = YunJi.getUrlParams('ticket')

export default {
  namespaced: true,
  state: {
    appCont: YunJi.getUrlParams('appCont'), // 0-H5 2-买家 1-卖家
    shopId: shopId, 
    ticket, 
    userType: -1, // 用于小程序中 钻石会员身份识别 1为钻石会员
    isApp: YunJi.isApp(), // 是否app标识
    searchType: 1, // 搜索框搜索类型
    searchDefaultValue: '搜索商品', // 搜索框默认值
    categoryType: YunJi.getUrlParams('categoryType') || 1, // 类目类型 云集类目ID是1 超市类目ID是2
    rightMenuType: 1, // 右侧导航栏类型 1为普通类型，2为新品推荐类型，3为品牌分类
    menuData: [], // 左侧导航栏列表
    categoryData: [], // 右侧数据栏
    categoryTotalData: JSON.parse(localStorage.getItem(`yj-${shopId}-category-total-data`) || '{}'), // 右侧访问数据集合 key 为categoryId
    bannerData: [], // 右侧顶部banner信息
    parentLevelName: null, // 传递给商品列表的一级类目名称
    categoryId: null, // 被选中的类目iD
    resourceId: null, // 被选中的资源位ID
    newGoodsTabId: 111, // 新品tab
    isReq: 0, // 是否请求中
    isErr: 0, // 请求是否异常
    isFinished: false, // 是否完成所有页面请求
    pageIndex: 0, // 当前页码
    contentIds: [], // 存放请求到的contentId
    newBannerReqStatus: 0, // 新品banner是否请求中 1 请求中 2异常 3没数据
    newGoodReqStatus: 3, // 新品是否请求中 1 请求中 2异常 3没数据
    newRecommdReqStatus: 3, // 新品推荐是否请求中 1 请求中 2异常 3没数据
    isSharing: false, // 分享中状态，ture代表当前正在分享中状态，需要特殊处理一些样式，比如把赚隐藏，显示划线价。
    historyFootprint: [] // 缓存足迹信息
  },
  mutations: {
    SETSEARCHVALUE(state, data) {
      state.searchDefaultValue = data || '搜索商品'
    },
    SETSEARCHTYPE(state, data) {
      state.searchType = data
    },
    SETMENUDATA(state, data) {
      state.menuData = [].concat(data)
    },
    SETCATEGORYDATA(state, data) {
      state.categoryData = data ? [].concat(data) : []
    },
    SETHISTORYFOOTPRINT(state, data) {
      state.historyFootprint = data
    },
    SETBANNERDATA(state, data) {
      state.bannerData = data ? [].concat(data) : []
    },
    SETPLNAME(state, data) {
      state.parentLevelName = data
    },
    SETCATEGORYID(state, data) {
      state.categoryId = data
    },
    SETRESOURCEID(state, data) {
      state.resourceId = data
    },
    SETRIGHTMENUTYPE(state, data) {
      state.rightMenuType = data
    },
    SETISREQ(state, data) {
      state.isReq = data
    },
    SETISFINISHED(state, data) {
      state.isFinished = data
    },
    SETPAGEINDEX(state, data) {
      state.pageIndex = data
    },
    SETISERR(state, data) {
      state.isErr = data
    },
    SETUSETYPE(state, data) {
      state.userType = data 
    },
    SETBANNERREQ(state, data) {
      console.log('banner', data)
      state.newBannerReqStatus = data 
    },
    SETNEWGOODRREQ(state, data) {
      console.log('商品', data)
      state.newGoodReqStatus = data 
    },
    SETNRECOMMDRREQ(state, data) {
      console.log('推荐', data)
      state.newRecommdReqStatus = data 
    },
    SET_IS_SHARING(state, data) {
      state.isSharing = data 
    },
    SETTOTALDATA(state, data) {
      const param = {
        ...state.categoryTotalData,
        ...data
      }
      state.categoryTotalData = param
      window.localStorage.setItem(`yj-${shopId}-category-total-data`, JSON.stringify(param))
    }
  },
  actions: {
    checkUserType({ commit, state }) {
      const { appCont, ticket } = state
      if (appCont != 7) return

      Http.checkIsDiamondMember({ 
        appCont,
        ticket
      }).then((res) => {
        res = res.data || {}
        // eslint-disable-next-line no-nested-ternary
        commit('SETUSETYPE', res.data ? (`${res.data.memberType}` ? res.data.memberType : -1) : -1)
      })
    },
    // 获取搜索框默认值
    async querySearchPage({ commit }) {
      const res = await Http.querySearchPage()
      if (res.errorCode === 0) {
        if (res.data.firstSearchName) commit('SETSEARCHVALUE', res.data.firstSearchName)
      }
    },
    async querySearchType({ commit, state }) {
      const categoryType = Number(state.categoryType)
      const res = await Http.querySearchType({ categoryType })
      if (res.errorCode === 0) {
        if (res.data && res.data.searchType) commit('SETSEARCHTYPE', res.data.searchType)
      }
    },
    // 获取导购页左侧菜单栏
    async queryCategoryName({ commit, dispatch, state }) {
      // commit('SETISREQ', 1)
      commit('SETISERR', 0)
      const categoryType = Number(state.categoryType)
      const { appCont } = state
      const res = await Http.queryCategoryName({ categoryType, appCont, strVersion: 1 })
      // commit('SETISREQ', 0)
      if (res.errorCode === 0) {
        if (res.data.categoryVOList) {
          commit('SETMENUDATA', res.data.categoryVOList)
          if (res.data.categoryVOList[0]) {
            const { categoryId, brandSaleZone, resourceId } = res.data.categoryVOList[0]
            commit('SETCATEGORYID', categoryId)
            const { categoryName } = res.data.categoryVOList[0]
            commit('SETPLNAME', categoryName)
            if (categoryId != state.newGoodsTabId) {
              if (brandSaleZone == 1 && resourceId) {
                commit('SETRIGHTMENUTYPE', 3)
                commit('SETRESOURCEID', resourceId)
                state.pageIndex = 0
                dispatch('getBrandSaleZoneList')
              } else {
                commit('SETRIGHTMENUTYPE', 1)
                dispatch('queryCategoryData', { categoryId })
              }
            } else {
              commit('SETRIGHTMENUTYPE', 2)
            }
          }
        }
      } else {
        commit('SETISERR', 1)
      }
    },
    resetContentIds({ state }) {
      state.contentIds = []
    },
    // 获取导购页右侧品牌团数据
    async getBrandSaleZoneList({ commit, state }) {
      const { 
        resourceId, appCont, pageIndex, categoryData, contentIds
      } = state
      const pageSize = 10
      commit('SETISREQ', true)
      commit('SETISFINISHED', false)
      const res = await Http.getBrandSaleZoneList({ 
        resourceId, pageIndex, pageSize, contentIds
      }, appCont)
      if (res.code === 0 && res.data && res.data.list) {
        if (pageIndex == 0) {
          commit('SETCATEGORYDATA', res.data.list)
        } else {
          commit('SETCATEGORYDATA', [...categoryData, ...res.data.list])
        }
        state.contentIds = res.data.contentIds
        const contentIds = res.data.list.map(item => item.contentId).join(',')
        window.thinkingReport.track('exposure', {
          point_id: '31853',
          page_id: '81442',
          tab_name: state.parentLevelName,
          content_id: contentIds
        })
        if (!state.contentIds || state.contentIds.length <= 0) {
          commit('SETISFINISHED', true)
        }
      } else {
        commit('SETCATEGORYDATA', [])
        commit('SETISFINISHED', true)
      }
      state.pageIndex += 1
      commit('SETISREQ', false)
    },
    // 获取导购页右侧数据栏
    async queryCategoryData({ commit, state }) {
      const channel = state.isApp ? 1 : 2
      const { categoryId, appCont } = state
      const strVersion = 1
      commit('SETISREQ', 1)
      commit('SETISERR', 0)
      // 先将老数据置空
      commit('SETBANNERDATA', [])
      commit('SETCATEGORYDATA', [])
      // 获取缓存足迹信息
      if (window.localStorage.getItem('historyFootprint')) {
        state.historyFootprint = JSON.parse(window.localStorage.getItem('historyFootprint'))
        commit('SETHISTORYFOOTPRINT', state.historyFootprint)
        // console.log(state.historyFootprint)
      }
      // 读取缓存，存在则先显示数据
      const data = state.categoryTotalData[categoryId]
      data && data.bannerVOList && commit('SETBANNERDATA', data.bannerVOList)
      data && data.guideListVOList && commit('SETCATEGORYDATA', data.guideListVOList)
      const res = await Http.queryCategoryData({ 
        categoryId, 
        channel, 
        appCont, 
        strVersion
      })
      if (res.errorCode === 0 && res.data) {
        const param = {}
        param[res.data.firstCategoryId] = {}
        if (res.data.bannerVOList) {
          param[res.data.firstCategoryId].bannerVOList = res.data.bannerVOList
        }
        if (res.data.guideListVOList) {
          param[res.data.firstCategoryId].guideListVOList = res.data.guideListVOList
        }
        if (Object.keys(param).length > 0) {
          commit('SETTOTALDATA', param)
        }
        if (res.data.firstCategoryId === state.categoryId) {
          commit('SETBANNERDATA', res.data.bannerVOList || [])
          commit('SETCATEGORYDATA', res.data.guideListVOList || [])
        }
        
        const { guideListVOList } = res.data
        if (guideListVOList && guideListVOList.length > 0) {
          guideListVOList.forEach((item) => {
            if (state.historyFootprint.length > 0 && item.guideDataType == 5 && item.historyCount > 0) {
              item.guideDataVOS = state.historyFootprint
            }
          })
        }
      } else {
        commit('SETISERR', 1)
      }
      commit('SETISREQ', 0)
    }
  }
}
